import { render, staticRenderFns } from "./PeriodicityMonthsSelector.vue?vue&type=template&id=6435f2e3&scoped=true"
import script from "./PeriodicityMonthsSelector.vue?vue&type=script&lang=js"
export * from "./PeriodicityMonthsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6435f2e3",
  null
  
)

export default component.exports